import { defineComponent as _defineComponent } from 'vue'
import { hostBaseUrl } from '@/utils/env';
import { computed, withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
    initials: null,
    imagePath: { default: undefined },
    currentUser: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { initials: string, imagePath: string, currentUser: boolean };



const fullImagePath = computed(() => {
  if (!props.imagePath) {
    return undefined
  }
  const imagePath = props.imagePath?.[0] !== '/' ? props.imagePath : `${hostBaseUrl()}${props.imagePath}`
  return imagePath
})

return { __sfc: true,props, fullImagePath }
}

})